<section class="bgcolor py-5 " style="background-image: url('assets/images/new_images/testimonials.jpg'); background-size: cover;">
  <div class="container-fluid">
    <div class="row">
<div class="col-md-12 text-center ">
  <h2> Testimonials </h2>
</div>
<div class="col-md-12 ps-5">
  <div class="testimonials-slide">
    
    <div class="item" *ngFor="let product of homeListdata?.testimonials">
<div class="Testimonialsbox">
  <div class="Testimonialsinfo">
    <p class="nametest">{{ product.full_name }} </p>
    <p class="profiletest"> {{ product.company_name }} </p>
  </div>
<p>{{product.description}}</p>
<p> {{product.description}} </p>
</div>
</div> 

          </div>





    </div>
    </div>
  </div>

</section>


<section style="background-image: url('assets/images/enquiry.jpg'); border-radius: 8px;" class="py-5 mt-3">
  <div class="container-fluid py-5">
<div class="row">
<div class="col-md-12">
  <div class="ctabox">
<h3 style="color: #fff !important;"> Tell us Your Enquiries</h3>
<!-- <a href="" class="btn"> Post Your Enquiries</a> -->
<button name="tellEnquiries" class="telladdListing" style="background-color: #FF642B;     color: #fff;
padding: 8px 15px;
border-radius: 8px;
background-size: cover;
">Post Your Enquiries </button>
</div>
</div>
</div>
</div>
</section>
